// pages/index.jsx
import React, { useRef } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Mission from "../components/Mission";
import Vision from "../components/Vision";
import Footer from "../components/Footer";
import ProductsAndServices from "../components/ProductsAndServices";
import Impacts from "../components/Impacts";
import Partners from "../components/Partners";
import SustainableDevelopmentGoalsAlignment from "../components/SustainableDevelopmentGoalsAlignment";

const Home = () => {
  const aboutRef = useRef(null);
  const missionRef = useRef(null);
  const visionRef = useRef(null);
  const ProductsandServiceRef = useRef(null);
  const impactsRef = useRef(null);
  const PartnersRef = useRef(null);
  const FooterRef = useRef(null);
  const sdgRef = useRef(null);

  const scrollToAbout = () => {
    aboutRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToMission = () => {
    missionRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToProductsandService = () => {
    ProductsandServiceRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToFooter = () => {
    PartnersRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToVision = () => {
    visionRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToSDB = () => {
    sdgRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="w-full overflow-hidden">
      <Header
        scrollToAbout={scrollToAbout}
        scrollToProductsandService={scrollToProductsandService}
        scrollToFooter={scrollToFooter}
      />
      <Hero />
      <About ref={aboutRef} />
      <Impacts />
      <Mission ref={missionRef} />
      <ProductsAndServices ref={ProductsandServiceRef} />
      <Vision ref={visionRef} />
      <SustainableDevelopmentGoalsAlignment ref={sdgRef} />
      <Partners />

      <Footer
        scrollToAbout={scrollToAbout}
        scrollToMission={scrollToMission}
        scrollToVision={scrollToVision}
        scrollToProductsandService={scrollToProductsandService}
        scrollToSDB={scrollToSDB}
        ref={FooterRef}
      />
    </div>
  );
};

export default Home;
